import logoUrl from '../assets/aawta-logo.png';

export function AawtaLogo({ size = 40, showText = true, dark = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="aawta-logo">
      <img
        src={logoUrl}
        alt="AAWTA Partnership Hub"
        style={{ height: size, width: 'auto' }}
        className="shrink-0"
      />
      {showText && (
        <div className="leading-tight">
          <div className={`font-heading font-extrabold text-base tracking-tight ${dark ? 'text-white' : 'text-navy'}`}>
            AAWTA
          </div>
          <div className={`text-[10px] tracking-widest uppercase font-semibold ${dark ? 'text-white/60' : 'text-slate-500'}`}>
            Partnership Hub
          </div>
        </div>
      )}
    </div>
  );
}
